import { z } from "zod";
import { CandidateEditableProfileSchema } from "./jobs";
import {
  CandidateEducationSchema,
  CandidateExperienceSchema,
  CandidateProjectSchema,
} from "./candidate-profile-details";

// Editor requirements are intentionally stricter than parsed/imported profile data.
export const CandidateProfileContactEditorSchema =
  CandidateEditableProfileSchema.pick({ name: true, email: true }).extend({
    name: z.string().trim().min(1).max(120),
    email: z.string().trim().email().max(254),
  });
export const CandidateEducationEditorSchema = CandidateEducationSchema.extend({
  institution: z.string().trim().min(1).max(200),
});
export const CandidateExperienceEditorSchema = CandidateExperienceSchema.extend(
  {
    title: z.string().trim().min(1).max(120),
  },
);
export const CandidateProjectEditorSchema = CandidateProjectSchema.extend({
  name: z.string().trim().min(1).max(200),
});
